/* eslint no-param-reassign: "off" */

import ElementUpdater from './elementUpdater'
import Selector from './selector'

const updateMonthView = (styles) => {
  const { backgroundColor, secondaryBackgroundColor, titleFontColor } = styles

  const monthViewBackgroundImageSelector =
    '.presentation_slide.month_view_slide .slide_background_image_wrapper'
  const slideContentsSelector =
    '.presentation_slide.month_view_slide .slide_contents'
  const adjacentMonthWrapperSelector =
    '.presentation_slide.month_view_slide .adjacent-month .clndr-day-contents-wrapper'
  const calendarSelector = '.presentation_slide.month_view_slide .clndr'
  const calendarDaySelector = '.presentation_slide.month_view_slide .clndr-day'
  const calendarDayContentsSelector =
    '.presentation_slide.month_view_slide .clndr-day-contents'
  const calendarDayContentsWrapperSelector =
    '.presentation_slide.month_view_slide .clndr-day-contents-wrapper'
  const calendarDaysSelector =
    '.presentation_slide.month_view_slide .clndr-days'
  const calendarHeaderSelector =
    '.presentation_slide.month_view_slide .clndr-header'
  const calendarHeaderContainerSelector =
    '.presentation_slide.month_view_slide .clndr-header-container'
  const calendarEventCountSelector =
    '.presentation_slide.month_view_slide .clndr-day-event-count'
  const calendarEventTitleSelector =
    '.presentation_slide.month_view_slide .clndr-day-event-title'
  const dateSelector = '.presentation_slide.month_view_slide .clndr-day-date'
  const dayTextSelector =
    '.presentation_slide.month_view_slide .clndr-header-day'
  const monthViewSelector = '.presentation_slide.month_view_slide .month-view'

  const fiftyPercentAlpha = '7C'
  const transparentBackgroundColor =
    secondaryBackgroundColor + fiftyPercentAlpha

  const selectors = [
    new Selector({
      selection: adjacentMonthWrapperSelector,
      required: true,
    }),
    new Selector({
      selection: slideContentsSelector,
      required: true,
    }),
    new Selector({
      selection: calendarSelector,
      required: true,
    }),
    new Selector({
      selection: calendarDaySelector,
      required: true,
    }),
    new Selector({
      selection: calendarDayContentsSelector,
      required: true,
    }),
    new Selector({
      selection: calendarDayContentsWrapperSelector,
      required: true,
    }),
    new Selector({
      selection: calendarDaysSelector,
      required: true,
    }),
    new Selector({
      selection: calendarHeaderSelector,
      required: true,
    }),
    new Selector({
      selection: calendarHeaderContainerSelector,
      required: true,
    }),
    new Selector({
      selection: calendarEventCountSelector,
    }),
    new Selector({
      selection: calendarEventTitleSelector,
    }),
    new Selector({
      selection: dateSelector,
      required: true,
    }),
    new Selector({
      selection: dayTextSelector,
      required: true,
    }),
    new Selector({
      selection: monthViewSelector,
      required: true,
    }),
    new Selector({
      selection: monthViewBackgroundImageSelector,
    }),
  ]

  const updateStyles = () => {
    document
      .querySelectorAll(monthViewBackgroundImageSelector)
      .forEach((element) => {
        element.style.top = '0'
      })

    document.querySelectorAll(slideContentsSelector).forEach((element) => {
      element.style['background-color'] = backgroundColor
      element.style.top = '80px'
    })

    document.querySelectorAll(calendarSelector).forEach((element) => {
      element.style.background = 'unset'
      element.style['border-top'] = `1px solid ${secondaryBackgroundColor}`
    })

    document
      .querySelectorAll(calendarDayContentsWrapperSelector)
      .forEach((element) => {
        element.style.background = 'unset'
      })

    document
      .querySelectorAll(adjacentMonthWrapperSelector)
      .forEach((element) => {
        element.style.background = transparentBackgroundColor
      })

    document
      .querySelectorAll(calendarDayContentsSelector)
      .forEach((element) => {
        element.style.background = 'unset'
      })

    document.querySelectorAll(monthViewSelector).forEach((element) => {
      element.style.background = 'unset'
      element.style.top = '115px'
    })

    document.querySelectorAll(dayTextSelector).forEach((element) => {
      element.style.color = titleFontColor
    })

    document.querySelectorAll(dateSelector).forEach((element) => {
      element.style.color = titleFontColor
    })

    document.querySelectorAll(calendarEventCountSelector).forEach((element) => {
      element.style.color = titleFontColor
      element.style.opacity = 0.7
    })

    document.querySelectorAll(calendarEventTitleSelector).forEach((element) => {
      element.style.color = titleFontColor
    })

    document.querySelectorAll(calendarHeaderSelector).forEach((element) => {
      element.style['border-color'] = secondaryBackgroundColor
    })

    document
      .querySelectorAll(calendarHeaderContainerSelector)
      .forEach((element) => {
        element.style.background = transparentBackgroundColor
      })

    document.querySelectorAll(calendarDaySelector).forEach((element) => {
      element.style['border-color'] = secondaryBackgroundColor
    })

    document.querySelectorAll(calendarDaysSelector).forEach((element) => {
      element.style['border-color'] = secondaryBackgroundColor
      element.style.background = 'unset'
      element.style.top = '25px'
    })
  }

  const updater = new ElementUpdater(selectors, updateStyles)
  updater.update()
}

export default updateMonthView
